import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { DesktopOnlyPage } from '@/app/pages/DesktopOnlyPage';
import { ROUTES } from '@/constants';
import { isMobileRoute } from './navigation';

/**
 * Mobile CMS routing: the dashboard (where sign-in lands) opens Displays, and
 * pages outside Displays/Buildings/Media show "use a computer". Hiding pages
 * is not a security boundary: the API still enforces permissions.
 */
export function MobileRouteGate({ children }: { children: ReactNode }) {
	const { pathname } = useLocation();

	if (pathname === ROUTES.home) {
		return <Navigate to={ROUTES.displays} replace />;
	}
	if (!isMobileRoute(pathname)) return <DesktopOnlyPage />;
	return children;
}
